// extracted by mini-css-extract-plugin
module.exports = {"bkw-C":"C_bkw-C___sme1"};